<section class="h5 d-flex flex-column flex-md-column flex-lg-row flex-xl-row gap-2">
  <strong class="mb-2">Step 4:</strong>
  <span class="fw-normal">Add Subscribe and Save items</span>
</section>
<p class="text-muted mb-3"><strong>Your veggies called. They’d like some friends.</strong> From meat and dairy to pantry
  staples, choose from the community’s top picks, direct from local farms and kitchens. Plus, save 5% on each item you
  subscribe to.</p>
<div class="row g-3 subscriptions-card-container">
  @if (isSubscriptionsLoading()) {
  <app-section-loader [message]="'Loading extra subscriptions...'"
    [loaderSize]="LoaderSizeEnum.LG"></app-section-loader>
  } @else {
  <div class="col-md-6" *ngFor="let sub of subs; trackBy: track">
    <div class="extra-card" [class.active]="isActive(sub.id)">
      <div class="thumb-wrapper">
        <div class="thumb rounded overflow-hidden">
          <img [src]="sub.img" (error)="onImageError($event)" alt="{{sub.name}}" (click)="$event.stopPropagation()" />
        </div>
      </div>
      <div class="d-flex flex-column justify-content-evenly flex-grow-1">
        <h6 class="title mb-1 fw-medium">{{ sub.name }}</h6>
        <div class="prices small mb-2">
          <span class="old">{{ sub.originalPrice | currency }}</span>
          <span class="new">{{ sub.price | currency }}</span>
          <span class="size">| {{ sub.display }}</span>
        </div>
        <div class="frequency-selector mb-2">
          <select class="form-select form-select-sm" [ngModel]="getSelectedFrequency(sub.id)?.id || ''"
            (ngModelChange)="onFrequencyChange(sub.id, $event)" [disabled]="frequencies().length === 0">
            @for (frequency of frequencies(); track frequency.id) {
            <option [value]="frequency.id">{{ frequency.name }}</option>
            }
          </select>
        </div>
        <button type="button" class="btn sub-btn btn-secondary" (click)="toggle(sub.id)"
          [class.added]="isActive(sub.id)">
          {{ isActive(sub.id)? 'Added':'Subscribe and Save' }}
        </button>
      </div>
    </div>
  </div>
  }
</div>
<div
  class="alert alert-light small fw-medium text-black text-center d-flex align-items-center justify-content-center gap-2 mt-4">
  <span>All set? If your box feels complete with this week’s essentials, continue to the next step.</span>
  <i class="fas fa-info-circle"></i>
</div>

<!-- Botón para continuar -->
<div class="d-flex justify-content-center mt-4">
  <button type="button" class="btn btn-primary px-4" [disabled]="!svc.canProceed('subscriptions')" (click)="onNext()">
    Next <span class="ms-1">→</span>
  </button>
</div>